import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import Authorizer, { PERMISSIONS } from '../../session/authorizer';
import Authentication from '../../session';
import { baseUrlAdmin } from '../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import Service from '../../../services';
import { getBoardsData } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import LoadingComponent from '../../loadingComponent';
import { SubjectIcon } from '../../svgIcons';
import AssignSubjectToStudents from './assignSubjectToStudents';
import './styles.css';

class SubjectAssignment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            boardId: null,
            classId: null,
            groupId: null,
            classes: [],
            curriculumInfo: {},
            selectedSubject: null,
            selectedSubjectIndex: null,
            isAssignDialogOpen: false,
            selectedBoardName: '',
            selectedClassName: ''
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.props.getBoardsData(true);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.boardId == null && this.props.boards.length) {
            this.setState({
                boardId: this.props.boards[0].boardId
            }, () => {
                this.onChangeBoard(this.state.boardId);
            });
        }
    }

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [],
            classId: null,
            curriculumInfo: {},
            selectedSubject: null
        });

        const _classes = [];
        const selectedBoard = this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        if (selectedBoard && selectedBoard.classes && selectedBoard.classes.length > 0) {
            selectedBoard.classes.forEach((each) => _classes.push({
                label: each.className,
                value: each.classId,
                groupId: each?.groups ? each?.groups[0]?.groupId : ''
            }));
        }

        let selectedBoardName = this.props.boards?.find((board) => board.boardId == boardId).boardName;
        this.setState({
            classes: _classes,
            boardId,
            selectedSubject: null,
            selectedBoardName: selectedBoardName
        });
    };

    onChangeClass = (classId) => {
        let selectedClass = this.state.classes?.find((classd) => classd.value == classId);

        this.setState(
            {
                classId: classId,
                selectedSubject: null,
                selectedClassName: selectedClass?.label,
                groupId: selectedClass?.groupId
            },
            () => this.getCurriculumData()
        );
    };

    getCurriculumData = () => {
        const { boardId, classId, groupId } = this.state;
        if (boardId && classId) {
            this.setState({ isLoading: true });
            this.service
                .get(
                    `${baseUrlAdmin}/subject?boardId=${boardId}&classId=${classId}&groupId=${groupId || 'NO_GROUP'}`,
                    true
                )
                .then((data) => {
                    if (data && data.res && data.res.Item) {
                        this.setState({
                            curriculumInfo: data.res.Item,
                            isLoading: false
                        });
                    } else {
                        this.setState({
                            curriculumInfo: {},
                            isLoading: false
                        });
                        this.toast.current.show({
                            severity: 'info',
                            summary: 'Info',
                            detail: 'No subjects found for this board and class',
                            life: 3000
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.setState({ isLoading: false });
                    this.toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch curriculum data',
                        life: 3000
                    });
                });
        } else {
            this.setState({
                curriculumInfo: {},
                isShowSubjects: false
            });
        }
    };

    onAssignClick = (subject, index) => {
        this.setState({
            selectedSubject: subject,
            selectedSubjectIndex: index,
            isAssignDialogOpen: true
        });
    };

    handleAssignDialogClose = () => {
        this.setState({
            isAssignDialogOpen: false,
            selectedSubject: null,
            selectedSubjectIndex: null
        });
        // Refresh curriculum data to get updated assignments
        this.getCurriculumData();
    };

    render() {
        const { curriculumInfo, selectedSubject, isAssignDialogOpen } = this.state;

        return (
            <div className="subject-assignment-container">
                <Toast ref={this.toast} />
                {this.state.isLoading && <LoadingComponent />}

                <div className="grid m-2">
                    <div className="col-3">
                        <ClassetDropdown
                            required={true}
                            label={'Board'}
                            placeholder={'Select Board'}
                            options={this.props.boards}
                            value={this.state.boardId}
                            onChange={(e) => this.onChangeBoard(e.value)}
                            optionLabel="boardName"
                            optionValue="boardId"
                        />
                    </div>
                    <div className="col-3">
                        <ClassetDropdown
                            required={true}
                            label={'Grade'}
                            placeholder={'Select Grade'}
                            options={this.state?.classes}
                            value={this.state.classId}
                            onChange={(e) => this.onChangeClass(e.value)}
                        />
                    </div>
                </div>

                <div className="grid col-12">
                    <div className="col-12">
                        {this.state.classId && this.state.boardId ? (
                            <h4 style={{ fontWeight: 'bold' }}>Subjects</h4>
                        ) : null}
                        <div className="ma-scroll-vr-smoke" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            <div className="grid">
                                {curriculumInfo?.subjects?.map((subject, index) => (
                                    <div key={index} className="col-12 md:col-6 lg:col-4">
                                        <div
                                            className="flex flex-column justify-content-between card cursor-pointer mb-2 p-3 shadow-3"
                                            style={{
                                                minHeight: '120px',
                                                backgroundColor: '#ffffff',
                                                borderLeft: '4px solid #0056D0'
                                            }}
                                        >
                                            <div className="flex flex-row justify-content-between align-items-start">
                                                <div className="flex flex-row justify-content-start align-items-center">
                                                    <div className="mr-3">
                                                        <SubjectIcon height={24} width={24} color={'#0056D0'} />
                                                    </div>
                                                    <div>
                                                        <div className="w-full flex justify-content-start">
                                                            <p
                                                                className="Montserrat24 text-overflow-ellipsis m-0"
                                                                style={{
                                                                    fontWeight: 'bold',
                                                                    fontSize: '18px',
                                                                    color: '#0056D0'
                                                                }}
                                                            >
                                                                {subject.subjectName.toUpperCase()}
                                                            </p>
                                                        </div>
                                                        <p className="m-0 mt-1" style={{ fontSize: '14px', color: '#666' }}>
                                                            {subject?.chapters?.length} Chapters
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-content-end mt-3">
                                                <button
                                                    className="p-button p-button-primary p-button-sm"
                                                    onClick={() => this.onAssignClick(subject, index)}
                                                    style={{
                                                        padding: '0.5rem 1rem',
                                                        fontSize: '14px',
                                                        backgroundColor: '#0056D0',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        color: 'white',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Assign
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {isAssignDialogOpen && selectedSubject && (
                    <AssignSubjectToStudents
                        visible={isAssignDialogOpen}
                        onHide={this.handleAssignDialogClose}
                        subject={selectedSubject}
                        boardId={this.state.boardId}
                        classId={this.state.classId}
                        groupId={this.state.groupId}
                        subjectKey={curriculumInfo.subjectKey}
                        toast={this.toast}
                    />
                )}
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo
});

export default connect(mapStatesToProps, { getBoardsData })(
    Authentication(withRouter(SubjectAssignment))
);
